import React, { useState } from 'react';
import { Typography, Box } from '@mui/material';
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from '../common/common';
import { useNavigate } from 'react-router-dom';
import { Title } from 'react-admin';
import Swal from 'sweetalert2';

const UploadZIP = (props) => {
    const navigate = useNavigate();

    const [showLoader, setShowLoader] = useState(false);
    const [successMsg, setSuccessMsg] = useState(false);
    const [validationTitleError, setValidationTitleError] = useState(false);
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
    const [errorMsg, setErrorMsg] = useState(false);
    const [errorMsgText, setErrorMsgText] = useState(null);
    const [inAppTitle, setInAppTitle] = useState('');
    const [fileUploaded, setFileUploaded] = useState(null);

    const titleChange = (e) => {
        if (e.target.value === '' || e.target.value === undefined || e.target.value === null || !e.target.value.trim().length) {
            setValidationTitleError(true);
        } else {
            setValidationTitleError(false);
        }
        setInAppTitle(e.target.value)
    };

    const formSave = () => {
        setShowLoader(true);
        setSaveButtonDisabled(false);

        const formData = new FormData();
        formData.append('name', inAppTitle.trim());
        formData.append('file', fileUploaded)

        const options = CommonHeaderOption();
        options.method = 'POST';

        const stateData = localStorage.getItem('__state');
        const userData = stateData ? JSON.parse(stateData) : false;

        options.headers = {
            'Authorization': userData._token,
        }
        options.body = formData;

        const url = `${RUN_TIME_API_ENDPOINT}/customer_bulk_file_downloads`;

        return fetch(url, options)
            .then(res => {
                console.log('fileUploadPDF Response', res)
                if (res) {
                    return res.json();
                }
            }
            )
            .then(res => {
                if (res.errorMsg) {
                    Swal.fire({
                        text: res.errorMsg || 'Something went wrong. Please try again',
                        confirmButtonText: `OK`,
                        icon: 'error'
                    });
                } else {
                    setSuccessMsg(true);
                    setTimeout(() => {
                        setSuccessMsg(false);
                    }, 2000)
                    setTimeout(() => {
                        navigate("/customer_file_downloads");
                    }, 1500)
                    console.log('res', res);
                }

            }).catch(error => {
                Swal.fire({
                    text: 'Something went wrong. Please try again',
                    confirmButtonText: `OK`,
                    icon: 'error'
                });
                console.log('Error Upload', error, error.body);
            }).finally(() => {
                setShowLoader(false);
                setSaveButtonDisabled(true);
            })

    }

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        const maxSizeInBytes = 50 * 1024 * 1024;
        const fileType = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length);

        if (file === null ||
            typeof (file) === 'undefined' ||
            file === '' ||
            typeof (file) === undefined ||
            !file ||
            fileType !== 'zip'
        ) {
            Swal.fire({
                text: 'Please choose a valid file.',
                confirmButtonText: `OK`,
                icon: 'error'
            });
            e.target.value = '';
            return;
        };

        if (file.size > maxSizeInBytes) {
            Swal.fire({
                text: 'File size should not be greater than 50MB.',
                confirmButtonText: `OK`,
                icon: 'error'
            });
            e.target.value = '';
            return;
        };

        if (file) {
            setFileUploaded(file);
        };
    }

    return (
        <div>
            <div className="so-form-container so-form-container-rh" style={{ marginTop: 15 }}>
                <div className="so-form" style={{ paddingBottom: 10, paddingTop: 10 }}>

                    <div className="so-input">
                        <label>Name<sup className="asterisk">*</sup></label>
                        <input
                            className="form-control"
                            type="text"
                            name="Title"
                            value={inAppTitle || ''}
                            onChange={titleChange}
                        />
                        {validationTitleError &&
                            <p className="so-input-error">Please enter a title</p>
                        }
                    </div>

                    <div className="csv-file-upload-container target-upload-container" style={{ marginTop: 0 }}>
                        <Typography variant="subtitle2" mb={1}><strong>Upload File :</strong></Typography>
                        <input
                            type="file"
                            id="file"
                            onChange={handleFileUpload}
                            accept=".zip,application/zip,application/x-zip-compressed"
                        />
                        <Box sx={{ mt: 4 }}>
                            <Typography variant="subtitle2"><strong>File Upload Instructions:</strong></Typography>
                            <ul style={{ paddingLeft: '20px', marginTop: '4px' }}>
                                <li>Allowed file types:  ZIP</li>
                                <li>Max file size (total): 50 MB</li>
                                <li>Please wait until all files are uploaded. Do not close the browser during the upload process, as it will cause the upload to fail.</li>
                                <li>Uploaded files may take up to 5 minutes to appear, depending on the size.</li>
                            </ul>
                        </Box>

                        <Box sx={{ mt: 4 }}>
                            <Typography variant="subtitle2"><strong>Important Notes:</strong></Typography>
                            <ul style={{ paddingLeft: '20px', marginTop: '4px' }}>
                                <li>The .zip file must only contain the following file types: .docx, .doc, .pdf, .xlsx, .xls, .csv, .png, .jpg, .jpeg</li>
                                <li>Each file inside the zip must be named exactly as the customer code without leading zeros.
                                    For example, for customer code 214813, the file should be named: 214813.pdf (not 00214813.pdf).</li>
                                <li>Files with names not matching a valid customer code will be ignored and not uploaded.</li>
                                <li>To get upload file format. <a
                                    href="https://clickit-static-files-prod.s3.eu-west-1.amazonaws.com/fille_formats/customer_downloads_format.zip"
                                    target="_blank">Click here</a> to download</li>
                            </ul>
                        </Box>
                    </div>
                </div>
                {saveButtonDisabled &&
                    <div className="so-save-button">
                        <button
                            style={{ color: '#FFF', fontWeight: '700', letterSpacing: 0.5 }}
                            className={!inAppTitle || validationTitleError || !fileUploaded ? 'disable-save' : ''}
                            disabled={validationTitleError || !inAppTitle || !fileUploaded}
                            onClick={() => formSave()}>Save</button>
                    </div>
                }

                {showLoader &&
                    <div className="save-loader" />
                }
                {successMsg &&
                    <div className="so-updated" >
                        Successfully Created </div>
                }
                {errorMsg &&
                    <div className="so-email-exist" >
                        {errorMsgText}</div>
                }
            </div>
        </div>
    )
}

export default UploadZIP;